import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { leadId: Number }
  
  async findEmail(event) {
    event.preventDefault()
    
    const button = event.currentTarget
    const originalText = button.textContent
    button.disabled = true
    button.textContent = 'Finding...'
    
    try {
      const response = await fetch(`/leads/inbox/${this.leadIdValue}/find_email`, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': this.csrfToken
        }
      })
      
      const data = await response.json()
      
      if (data.success) {
        this.showNotification(`Email found: ${data.email}`, 'success')
        setTimeout(() => window.location.reload(), 1000)
      } else {
        this.showNotification(data.error || 'Email not found', 'error')
      }
    } catch (error) {
      this.showNotification('Error finding email', 'error')
    } finally {
      button.disabled = false
      button.textContent = originalText
    }
  }
  
  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ''
  }
  
  showNotification(message, type) {
    window.dispatchEvent(new CustomEvent('notification:show', {
      detail: { message, type }
    }))
  }
}

